import React from 'react';
import { Table } from 'reactstrap';

import AddressHelper from '@components/Elements/AddressHelper/AddressHelper';
import SortableTh from '@components/SortableTh/SortableTh';

export default props => {
  return (
    <Table className={'mt-3'} hover={true}>
      <thead>
        <tr>
          <SortableTh {...props} label={'Name'} field={'name'} />
          <SortableTh
            {...props}
            label={'Contact Name'}
            field={'contact_name'}
          />
          <SortableTh {...props} label={'Phone'} field={'phone'} />
          <SortableTh {...props} label={'Email'} field={'email'} />
          <SortableTh {...props} label={'Address'} field={'address'} />
        </tr>
      </thead>
      <tbody>
        {props.entities.map(item => {
          return (
            <tr
              className={'pointer'}
              key={'management-company-' + item.id}
              onClick={() => props.onEntityClick(item.id)}
            >
              <td>{item.name}</td>
              <td>{item.contact_name}</td>
              <td>{item.phone}</td>
              <td>{item.email}</td>
              <td>
                <AddressHelper {...item} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
